import React from 'react'

/**
 * Notice — inline message banner for errors and warnings (form errors,
 * Jira sync problems). Soft tinted background, no icon by default.
 */
export function Notice({ variant = 'error', children, className = '' }) {
  const cls = ['notice', `notice-${variant}`, className].filter(Boolean).join(' ')
  return <div className={cls}>{children}</div>
}
